
  export default {
    transitions: 'page',
    data: () => ({
      loading: true
    }),
    async mounted () {
      await this.finish()
      setTimeout(() => {
        this.loading = false
      }, 500)
    },
    methods: {
      start() {
        this.loading = true
      },
      finish() {
        return new Promise (resolve => {
          setTimeout(() => {
            this.$el.classList.add('animate__slow')
            this.$el.classList.add('animate__fadeOut')
            resolve()
          }, 2500)
        })
      }
    },
  }
